<template>
  <Modal :id="'cpm-add-track-list-modal'" @cancelled="onCancel">
    <template slot="header">{{$t('copy_tracks')}}</template>

    <template slot="body">
      <!-- <span>c{{ existing }} p{{ new }}</span> -->

      <div  class="fform-group">
            <SearchList
                :id="'catalogList'"
                 ref="venueSearchList"
                :items="catalogList"
                :keyProperty="'product_id'"
                :label="'catalog_no'"
                :selectionNumber="'single'"
           
                @searched="searchTrack"
              >
                <template v-slot:item="{ item }">
                  <tr class="dt-table2--row">
                    <dt class="dt-table2--column" style="border-right:1px solid #fefefe">
                   
                        <div class="contact-type">
                            <input
                                    type="radio"
                                    style="margin-top: 5px; margin-bottom: auto; margin-right: 8px;"
                                    @change="(e) => onChangeContactType(e,item)"
                                    value="new"
                                    name="contact"
                            />
                            <label
                                for="contact"
                                @click="(e) => onChangeContactType(e,item)"
                            >{{item['catalog_no']}}</label>
                        </div>
                      
                                         
                    </dt>
                   
                  
                  </tr>
                </template>
              </SearchList>
      </div>

    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{$t('cancel')}}
      </button>
      <!-- <button  @click.stop="addNewTrack" class="dt-button v1 with-ico"> OK </button> -->
     
    </template>
  </Modal>
</template>

<script>
import { createValidator } from "@plugins/text-field";



import Modal from "@/dt-plugins/modal/modal";
import { tv } from "../../../../models/text-value.model";
import { releaseService } from '../../services/releases/releases.services';
import { ProductsService } from '../../services/products.service';

import SearchList from "@dtplugins/search-list/search-list";
import { addRemoveSet } from '../../../../utility';
import DTCheckbox from '../../../../plugins/checkbox/checkbox';



export default {
  components: {
    Modal,
    SearchList,
    DTCheckbox
  
  },
  props: {},
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
      },

      textFieldConfig2: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },

      loading: true,

     
      formatId:16,
      enteredCatalogNo:'',
      validationResult: {},
      catalogList:[],
      digitalRightType:'',
      artists:"",
    
    
      bonus_track_flag:0,
      selectedTracks: new Set(),

      
    };
  },
  mounted:async function () {
    //   type operation = Boolean | 'toggle';

      const resData=await ProductsService.productCatalogs(this.external_id);
      console.log("RES DATA",resData);
      this.catalogList=resData.data.products;
    

  },
  computed: {
    external_id: function() {
      return this.$route.query.external_id;
    },
    rightsTV:function(){
      return [
          { text:"Full Rights",value:"1" },
          { text:"Bundle Only",value:"2" },
          { text:"No Digital Rights",value:"3" },
      ]
    },

    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    }

 
  },
  methods: {
    onCheckboxChange: function(event, name, item) {
      const value = event.target.checked;
       this.selectedTracks = addRemoveSet(
        event.target.checked,
        this.selectedTracks,
        item.track_id
      );
      console.log("WWWW",item.track_id,value);
    },
    onChangeContactType:  function (event,item) {
      console.log("ITEM",item);
      const payload=
        { 
          main_product_id :this.external_id,
          product_id	  : item.product_id
        }

        this.$emit("create",payload)
      //this.trackType = type;
      // this.company = {};
      // this.person = {};

      //await wait(20);

      // this.company = createCompany();
      // this.person = createPerson();

      // console.log({
      //   company: this.company,
      //   person: this.person,
      // });
    },
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onTextFieldValueChange: function (key, value) {
      console.log("KEY,VALUE",key,value)
      this[key]=value

    },


    onCancel: function () {
      this.$emit("cancelled", true);
    },

    addNewTrack: function (e) {

    //   console.log("WERE",Array.from(this.selectedTracks).join(","),this.selectedTracks)
    //   let payload={};
    //   if(this.trackType=="existing"){
    //      payload={ 
    //             product_id:this.external_id,
    //             track_list:Array.from(this.selectedTracks).join(","),
    //             name:'existing'
    //           };
    //   }else{
    //     payload={
    //       name:'new',
    //       product_id	:this.external_id,
    //       title	: this.title,
    //       version	: this.version,
    //       artist	: this.artist,
    //       playtime	: this.playtime,
    //       isrc	: this.isrc,
    //       digital_right_type :this.digitalRightType

    //     }
    //   }
      
      
    //    this.$emit("create",payload)

    },
    onRadioChange: function (item) {
      console.log("TYPE",item)
      this.formatId=item.format_id
    },
    onFormatChange: function (value) {
      console.log("VALUE",value)
      this.digitalRightType=value.value
    },
    onBonusCheck:function(event)
    {   
        if(event.target.checked)
        {
          this.bonus_track_flag=1
        }
        else
        {
          this.bonus_track_flag=0
        }
         
    },
    searchTrack:async function(searchString){
      const resData=await ProductsService.searchProductCatalogs(this.external_id,searchString);
      console.log("RES DATA",resData);
      this.catalogList=resData.data.products;
    }

    //MARK: Methods
  },
};

const createPerson = ({
  firstName = "",
  lastName = "",
  email = "",
  phone = "",
  group = [],
} = {}) => {
  return {
    firstName,
    lastName,
    email,
    phone,
    group,
  };
};

const createCompany = ({
  companyName = "",
  city = "",
  country = "",
  group = [],
} = {}) => {
  return {
    companyName,
    city,
    country,
    group,
  };
};
</script>

<style lang="scss">
.cpm-add-track-list-modal{
  
  .form-group {
    display: flex;
    flex-direction: column;

    // .dt-input-box--container {
    //   flex: 1;
    //   margin: 5px 0px;
    //   margin-left: 0px;
    // }
    .ut-flex{
      .checkbox-container{
        flex:0.1
      }

      .txtov{
        flex:0.9
      }
    }
    .group-input {
      // margin-top: 25px;
      // margin-bottom: 10px;
      // margin-right: 5px;

      min-height: 42px;
    }
  }

  .new-controls,
  .existing-controls {
    height: 249px;
  }

  .contact-type-selection {
    display: flex;
    flex-direction: column;
    padding: 0px;
    margin-bottom: 10px;
    .contact-type {
      flex: 1;
      display: flex;
      margin: 4px 0px;

      input {
        margin: auto 0;
      }
      label {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .dt-modal--options {
    display: flex;
    justify-content: flex-end;
    button {
      flex: 1;
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 10px;
      }
    }
  }

  .search-row {
    display: flex;
    &.chbx-row {
      .search--input-c {
        padding: 0px 5px;
      }
    }
    .search--input {
      flex: 1;
      max-width: 394px;
    }
    .search--checkbox {
      min-width: 20px;

      // padding-top: 15px;
      margin-left: 4px;

      display: flex;
      flex-direction: column;
      justify-content: center;

      }
    }
}
</style>
